import React from 'react';
import { Outlet } from 'react-router-dom';
import { View } from '@aws-amplify/ui-react';
import SiteNavBar from './SiteNavBar';
import SiteFooter from './SiteFooter';

export default function Layout() {
	return (
		<View minHeight="100vh" display="flex" direction="column">
			<SiteNavBar />
			<View as="main" flex="1">
				<Outlet />
			</View>
			<SiteFooter />
		</View>
	);
}
